import { animated } from "react-spring";

const CardExperiment = ({ card, x, y, rotate, width = 80 }) => {
  return (
    <animated.img
      src={"/cards/BLUE_BACK.svg"}
      alt={card}
      style={{
        pointerEvents: "none",

        position: "absolute",
        left: x.to((x) => `${x}px`),
        top: y.to((y) => `${y}px`),
        transform: rotate.to((rotate) => `rotate(${rotate}deg)`),

        width: `${width}px`,
        backgroundColor: "white",
        border: "1px solid black",
        borderRadius: "5px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    />
  );
};
export default CardExperiment;
